import React from 'react';
import Box from '@mui/material/Box';

import { FilterChips } from '../FilterChips';
import { ResetAllButton } from '../ResetAllButton';
import type { Filters } from '../../../filters';
import { useFilters } from '../../../filtersContext/filtersContext';
import { useEnabledFilters } from '../../../useEnabledFilters';

export const AppliedFilters = () => {
  const { enabledFilters } = useEnabledFilters();
  const { setFilter } = useFilters();
  const excludedChips = ['location', 'dates'];
  const moreFilters: Filters = Object.keys(enabledFilters)
    .filter((key) => !excludedChips.includes(key))
    // @ts-ignore
    .reduce((obj, key) => ((obj[key] = enabledFilters[key]), obj), {});
  return (
    <>
      {Object.keys(moreFilters).length > 0 && (
        <Box display="flex">
          <FilterChips filters={moreFilters} onDelete={(key) => setFilter(key)(undefined)} />
          <ResetAllButton />
        </Box>
      )}
    </>
  );
};
